// removed by extract-text-webpack-plugin
module.exports = {"saturation":"magazines_1AwHS","circle":"magazines_3I_tT","hue":"magazines_3YI0R","inputColor":"magazines_18qvD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorPicker/styles.scss
// module id = 1080
// module chunks = 1